import React, { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import { toast } from "react-toastify";
import { ImSpinner2 } from "react-icons/im";
import { fetchMarket } from "../../../redux/slices/marketSlice";
import { useDispatch, useSelector } from "react-redux";
import { updateDuplicateProduct } from "../../../redux/slices/productSlice";

export default function UpdateDuplicateProductMarket({
  owner_id,
  clearSelectedProductIds,
  selectedProductIds,
  city,
  state,
  country,
}) {
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const ownerId = owner_id;
  const ownerType = "market";

  // Fetch market data
  useEffect(() => {
    dispatch(fetchMarket());
  }, [dispatch]);

  const status = useSelector((state) => state.product?.status);

  // Initialize form data
  const initialFormData = {
    product_ids: selectedProductIds,
    city,
    state,
    country,
  };

  const [formData, setFormData] = useState({ ...initialFormData });

  // Update formData when selectedProductIds changes
  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      product_ids: selectedProductIds,
    }));
  }, [selectedProductIds]);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await dispatch(
        updateDuplicateProduct({
          ownerType,
          ownerId,
          formData,
        })
      );

      clearSelectedProductIds();
      setFormData({ ...initialFormData });
      toast.success(res.payload.data.message);
    } catch (error) {
      console.error(error);
    }
    setShowModal(false);
  };

  return (
    <>
      <button
        type="button"
        onClick={() => setShowModal(true)}
        className="flex gap-[8px] bg-blue-200 text-blue-600 items-center py-2 px-4 text-[14px] hover:shadow-lg rounded-[8px] font-medium"
      >
        Update Duplicated
      </button>
      {showModal ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-auto my-6 mx-auto max-w-5xl">
              <div className="border-0 rounded-lg p-6 shadow-lg relative flex flex-col bg-white outline-none focus:outline-none">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center"
                >
                  <FaTimes className="text-gray-300 text-xl" />
                  <span className="sr-only">Close modal</span>
                </button>
                <div className="text-center">
                  <h1 className="text-2xl text-gray-800 text-center font-medium mb-4">
                    Update Duplicated
                  </h1>
                </div>
                <div className="flex items-center px-8 py-4 gap-6">
                  <div className="flex mt-8 gap-4 justify-center">
                    <button
                      onClick={() => setShowModal(false)}
                      className="text-sm text-blue-500 font-semibold bg-blue-100 py-2 px-4 rounded-lg"
                    >
                      Cancel
                    </button>
                    <button
                      className="flex gap-1 rounded-lg items-center bg-blue-600 text-white py-2 px-4"
                      disabled={status === "loading"}
                      onClick={handleSubmit}
                    >
                      {status === "loading" ? (
                        <>
                          <ImSpinner2 className="animate-spin" />
                          <p className="text-sm font-semibold whitespace-nowrap">
                            Duplicating...
                          </p>
                        </>
                      ) : (
                        <>
                          <FaTimes className="w-4 h-4" />
                          <p className="text-sm font-semibold whitespace-nowrap">
                            Duplicate
                          </p>
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
}
